<div [formGroup]="searchConditionForm">
  <mat-expansion-panel class="expansion-panel-card" [expanded]="true">
    <mat-expansion-panel-header class="mat-panel-header-text">
      <mat-panel-title>検索条件</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
      <mat-form-field appearance="outline"
        class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-[550px] tw-max-w-[550px] tw-min-w-[550px]"
        floatLabel="always">
        <mat-label>督促管理区分</mat-label>
        <input matInput style="display: none!important" formControlName="pressManagementdivisionCode">
        <mat-selection-list formControlName="pressManagementdivisionCode" class="tw-flex tw-flex-row tw-flex-wrap"
          style="display: flex;" >
          <mat-list-option *ngFor="let status of codeMap?.get('S300090')" [value]="status.userCode"
            (selectedChange)="getControl('pressManagementdivisionCode')?.markAsTouched()" class="mat-list-option"
            color="primary" checkboxPosition="before">
            {{status.hyojiCont}}
          </mat-list-option>
        </mat-selection-list>
      </mat-form-field>
    </div>
    <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
      <mat-form-field appearance="outline"
        class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
        <mat-label>会社</mat-label>
        <mat-select formControlName="companycode" class="disabled-select-color" (valueChange)="onChangeCompany($event)">
          <mat-option [value]="null"></mat-option>
          <mat-option *ngFor="let company of companyList" [value]="company.value">{{company.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline"
        class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
        <mat-label>地区</mat-label>
        <mat-select formControlName="areacode" autocomplete="off">
          <mat-option [value]="null"></mat-option>
          <mat-option *ngFor="let chiku of chikuList" [value]="chiku.value">{{chiku.viewValue}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
      <mat-form-field appearance="outline"
        class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
        <mat-label>料金区分</mat-label>
        <mat-select formControlName="chargeDivcd" autocomplete="off">
          <mat-option [value]="null"></mat-option>
          <mat-option *ngFor="let type of codeMap?.get('S300620')"
            [value]="type.userCode">{{type.hyojiCont}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline"
        class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
        <mat-label>督促ステータス</mat-label>
        <mat-select formControlName="searchconditionPressStatuscode" autocomplete="off">
          <mat-option [value]="null"></mat-option>
          <mat-option *ngFor="let type of codeMap?.get('S301520')"
            [value]="type.userCode">{{type.hyojiCont}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
      <mat-form-field appearance="outline"
        class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
        <mat-label>督促管理区分変更年月日（開始）</mat-label>
        <input matInput [matDatepicker]="start" formControlName="koufuYearmonthdateStart" maxlength="10">
        <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
        <mat-datepicker #start></mat-datepicker>
      </mat-form-field>
      <span style="margin-left: 40px;">～</span>
      <mat-form-field appearance="outline"
        class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
        <mat-label>督促管理区分変更年月日（終了）</mat-label>
        <input matInput [matDatepicker]="end" formControlName="koufuYearmonthdateEnd" maxlength="10">
        <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
        <mat-datepicker #end></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
      <mat-action-row class="btn_area_right expansion-panel-actions">
        <button type="submit" mat-raised-button color="primary" class="btn"
          [disabled]="searchConditionForm.invalid">検索</button>
      </mat-action-row>
      <mat-action-row class="btn_area_right expansion-panel-actions">
        <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickClear()">クリア</button>
      </mat-action-row>
    </div>
  </mat-expansion-panel>
</div>